import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormTextField from '../../legacyForm/FormTextField';
import SmsIcon from '@material-ui/icons/Textsms';
import { Button, FormHelperText, Grid, Typography } from '@material-ui/core';

const required = value => value ? undefined : 'Pole jest wymagane';

class PhoneNumber extends React.Component {
  state = {
    verificationStarted: false,
    verificationStarting: false,
    phoneNumber: null,
    phoneNumberError: null,
  }

  validatePhoneNumber = value => {
    if (!value) return 'Pole jest wymagane';
    if (this.state.phoneNumberError) return this.state.phoneNumberError;
    if (!/^\s*(\d\s*){9}$/.test(value)) return 'Numer telefonu musi składać się z 9 cyfr';
    return undefined;
  }

  handlePhoneNumberChanged(phoneNumber) {
    this.setState({ phoneNumber, phoneNumberError: null });
  }

  handleStartVerification = () => {
    this.setState({ phoneNumberError: false, verificationStarting: true });
    this.props.change('phoneVerification', null);
    this.props
      .onStartVerification(this.state.phoneNumber, this.props.verificationMethodId)
      .then(result => {
        if (!result.error) {
          this.props.change('phoneVerification.token', result.token);
          this.setState({ verificationStarted: true });
        } else if (result.error.alreadyVoted) {
          this.setState({ verificationStarted: false, phoneNumberError: 'Podany numer telefonu został już wykorzystany w głosowaniu' });
        }
      })
      .finally(() => this.setState({ verificationStarting: false }));
  }

  render() {
    const { helperText, manualVote } = this.props;
    const verifyPhoneNumber = this.props.phoneVerificationEnabled && !manualVote;
    const phoneNumberIsOptional = this.props.voterRequiredData.phoneNumberOptional || (manualVote && this.props.phoneVerificationEnabled);
    const { verificationStarted, verificationStarting, phoneNumberError } = this.state;
    return (
      <React.Fragment>
        <Grid container spacing={1} justify="flex-start" alignItems="center">
          <Grid item xl>
            <Field
              name="voter.phoneNumber"
              disabled={verificationStarted}
              component={FormTextField}
              label="Numer telefonu"
              validate={phoneNumberIsOptional ? undefined : this.validatePhoneNumber}
              onChange={(_, value) => this.handlePhoneNumberChanged(value)}
            />
            {phoneNumberError && <FormHelperText error>{phoneNumberError}</FormHelperText>}
            {helperText && <Typography variant="caption" component="div">{helperText}</Typography>}
          </Grid>
          {verifyPhoneNumber && !verificationStarted && <Grid item xs>
            <Button color="primary"
              disabled={verificationStarting || this.validatePhoneNumber(this.state.phoneNumber) != null}
              onClick={this.handleStartVerification}>
              Weryfikacja numeru
              <SmsIcon style={{ fontSize: 20, marginLeft: 8 }} />
            </Button></Grid>}
          {verifyPhoneNumber && verificationStarted && <Grid item xs><Field
            name="phoneVerification.code"
            component={FormTextField}
            label="Kod weryfikacyjny SMS"
            validate={required}
          /></Grid>
          }
        </Grid>
      </React.Fragment>);
  }
}

PhoneNumber.propTypes = {
  voterRequiredData: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  phoneVerificationEnabled: PropTypes.bool.isRequired,
  onStartVerification: PropTypes.func,
  helperText: PropTypes.string,
  verificationMethodId: PropTypes.string,
  manualVote: PropTypes.bool,
};

export default PhoneNumber;



// WEBPACK FOOTER //
// ./src/components/budget/voting/PhoneNumber.js